<template>
  <div class="status-list scroll-styling rounded-lg ">
    <div class="relative">
        <div 
            class="mt-5 relative shadow-md sm:rounded-lg">
            <div class="table-container inl-100 tsor-table ">
                <CalendarTable />
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import CalendarTable from '@/components/Calendar/Table.vue'

export default {
  components: {
    CalendarTable
  },
  data() {
    return {
    };
  },
  methods: {

  },
  props: {},
};
</script>